import service from './base'
import setSignHead from './setSignHead'
const BASE_URL = '/'
const http = service.service
export const getPayRecordList = (params = {}) => {
    setSignHead.setCmdType('queryOrder')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/pay`, params)
}
export const getConList = (params = {}) => {
    setSignHead.setCmdType('sourceDetailed')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/qrcode`, params)
}
export const getRefundList = (params = {}) => {
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/refund/queryRefundOrder`, params)
}
export const checkCard = (params = {}) => {
    setSignHead.setCmdType('cardReview')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}
export const getCheckCardList = (params = {}) => {
    setSignHead.setCmdType('queryCardReview')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}
export const getHelp = (params = {}) => {
        setSignHead.setCmdType('showNewsContentList')
        return http.post(`${BASE_URL}AppServerWhpe/com/whpe/newsContent`, params)
    }
    // 充值，挂失前查询
export const userCardQuery = (params = {}) => {
    setSignHead.setCmdType('userCardQuery')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}


//  特殊卡年审
export const cardReview = (params = {}) => {
    setSignHead.setCmdType('cardReview')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}

//  新办卡地址配置
export const address = (params = {}) => {
    setSignHead.setCmdType('address')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}

//  新办卡金额配置
export const cardAmountSetting = (params = {}) => {
    setSignHead.setCmdType('cardAmountSetting')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}

//  充值订单
export const queryOrder = (params = {}) => {
        setSignHead.setCmdType('queryOrder')
        return http.post(`${BASE_URL}AppServerWhpe/com/whpe/pay`, params)
    }
    //  年审订单
export const queryCardReview = (params = {}) => {
    setSignHead.setCmdType('queryCardReview')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}


//  挂失补办订单+新办卡订单
export const queryCardNewApply = (params = {}) => {
    setSignHead.setCmdType('queryCardNewApply')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}

// 普通卡,学生卡新办(自取+邮寄)，补办
export const cardNewApply = (params = {}) => {
    setSignHead.setCmdType('cardNewApply')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}

// 年审+新办列表取消
export const cardNewApplyRefund = (params = {}) => {
    setSignHead.setCmdType('cardNewApplyRefund')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}

//使用帮助
export const questioneList = (params = {}) => {
    setSignHead.setCmdType('cardNewApplyRefund')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/card`, params)
}